<ul class="timeline">
  <li>
    <h3>1. Pick a policy</h3>
  </li>
</ul>
